import { syliusFetch } from '../../../entities/@api/Sylius';
import { Brand, BrandItemSyliusResponse } from '../../../entities/Brand/Brand';
import { transformToBrandForOverview, transformToBrandNavigation } from '../../../entities/Brand/BrandTransformers';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { ReduxFetchAction } from '../../defaults';
import {
    setBrands,
    setError,
    setHasFetched,
    setIsLoading,
    setIsSuccessful,
    setNavigation,
} from './brandsSlice';

export const fetchBrands: ReduxFetchAction = () => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setNavigation(undefined));
    dispatch(setBrands([]));

    try {
        const brandsResponse = await syliusFetch<BrandItemSyliusResponse[]>('/shop/brands');

        if (!isFetchResultSuccessful(brandsResponse)) {
            dispatch(setError(brandsResponse.error));
            return;
        }

        const brandsData = Object.values(brandsResponse.data);

        const brands: Brand[] = brandsData.length
            ? brandsData.map(transformToBrandForOverview)
            : [];

        const filteredBrands = brands
            .filter(brand => brand.name && brand.slug)
            .filter(brand => brand.variants);

        dispatch(setBrands(filteredBrands));

        const navigation = filteredBrands.length
            ? transformToBrandNavigation(filteredBrands)
            : undefined;

        dispatch(setNavigation(navigation));
        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchBrands]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};
